<template>
  <div>
    <QueryFrame
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :current="page"
      :count="count">
      <div slot="queryParams" class="queryContainer">
        <div class="queryItem" v-if="roleType!==2">
          <label>门店名称:</label>
          <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
        </div>
        <div class="queryItem">
          <label>查询期限:</label>
          <timeStampDatePicker type='daterange' class="item" v-model="query.range" placeholder="请选择"></timeStampDatePicker>
        </div>
        <div class="queryItem">
          <label>商品仓库:</label>
          <lk-select class="item" v-model="query.warehouseIds" filterable clearable>
            <lk-option v-for="item in warehouseList" :value="item.id" :key="item.id">{{ item.name }}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>

          <!-- <label>商品搜索:</label>
          <lk-input class="item" v-model.trim="query.keyword" :maxlength="100" clearable
                    placeholder="商品名称、商品编码、助记码、通用名称"></lk-input> -->
        </div>
        <div class="queryItem">
          <label>商品类型:</label>
          <lk-select class="item" v-model="query.type" clearable>
            <lk-option v-for="(item, index) in getNormalGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem storeSelect">
          <label>供应商:</label>
          <SupplierListSelect multiple v-model="query.supplierIds"></SupplierListSelect>
        </div>
        <div class="queryItem storeSelect">
          <label>业务类型:</label>
          <lk-select class="item" multiple v-model="query.bizTypes">
            <lk-option v-for="item in bizTypes" :value="item[0]" :key="item[0]">{{ item[1] }}</lk-option>
          </lk-select>
        </div>
        <!-- <div class="queryItem">
          <label>商品类型:</label>
          <lk-select class="item" v-model="query.type" clearable>
            <lk-option v-for="(item, index) in getGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
          </lk-select>
        </div> -->
        <div class="queryItem">
          <label>来源:</label>
          <lk-select class="item" v-model="query.purchaseType" clearable>
            <lk-option v-for="(item, index) in getGoodsOrigin" :key="index" :value="item.value">{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>批次号:</label>
          <lk-input
            :maxlength="100"
            placeholder="请输入批次号"
            class="item"
            clearable
            v-model.trim="query.batchSeq">
          </lk-input>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr" @click="handleSearch(false,getDetails)">查询</lk-button>
          <lk-button class="mr" @click="handleReset">重置</lk-button>
        </div>
      </div>
      <div slot="table">
        <!-- 异步导出Excel Start -->
        <DownloadButton class="mb16" @on-click="download" v-if="handlePermission('stockDetailExcel')"></DownloadButton>
        <!-- 异步导出Excel End -->
        <SummaryList :summaryList='summaryList'></SummaryList>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';
// import timeStampDatePicker from '../../components/timeStampDatePicker.vue';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import DownloadButton from '../../components/download/DownloadButton';
import SupplierListSelect from '../../components/SupplierListSelect.vue';
import SummaryList from '../../components/SummaryList.vue';

export default {
  name: 'stockDetail',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    // timeStampDatePicker,
    DownloadButton,
    SupplierListSelect,
    SummaryList,
  },
  computed: {
    ...mapGetters([
      'getGoodsOrigin',
      'getNormalGoodsTypes',
    ]),
    // ...mapGetters(['getNormalGoodsTypes']),

    // goodsTypes() {
    //   return this.$store.state.publicParams.goodsTypes;
    // },
  },
  data() {
    return {
      summaryList: [
        {
          title: '合计数量',
          value: '1',
        },
      ],
      warehouseList: [],
      bizTypes: new Map([
        [1, '验收入库'],
        [2, '销售退货'],
        [3, '库存损溢加'],
        [4, '销售出库'],
        [5, '供应商退货'],
        [6, '库存报损'],
        [7, '库存损溢减'],
        [8, '药品召回'],
        [13, '采购成本调整'],
        [14, '销售成本调整'],
        [15, '其他成本调整'],
        [20, '拆零出库'],
        [21, '拆零入库'],
      ]),
      query: {
        storeIdList: null,
        range: [],
        warehouseIds: [],
        goodsType: null,
        supplierIds: null,
        bizTypes: [],
        startTime: null,
        endTime: null,
        type: null, // 商品类型
        purchaseType: 1, // 来源
      },
      columns: [
        {
          title: '业务类型',
          key: 'bizTypeStr',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '商品类型',
          key: 'goodsTypeName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '来源',
          key: 'purchaseType',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => {
            let purchaseTypeName = '';
            this.getGoodsOrigin.forEach((item) => {
              if (item.value === row.purchaseType) {
                purchaseTypeName = item.name;
              }
            });
            return h('span', purchaseTypeName);
          },
        },
        {
          title: '业务单号',
          key: 'bizOrderNumber',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '行号',
          key: 'bizItemNumber',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '业务时间',
          key: 'createTime',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '商品编码',
          key: 'drugSerialCode',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '商品名称',
          key: 'goodsName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '商品通用名称',
          key: 'approvedDrugNames',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '产地',
          key: 'origin',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '生产厂家',
          key: 'producer',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '是否DTP',
          key: 'isDtpStr',
          minWidth: 116,
        },
        {
          title: '上市许可持有人',
          minWidth: 120,
          tooltip: true,
          key: 'mah',
        },
        {
          title: '剂型',
          key: 'dosageForm',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '供应商编码',
          key: 'supplierCode',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '供应商名称',
          key: 'supplierName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '单位',
          key: 'drugMiniPackageUnit',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '批次',
          key: 'goodsBatchSeq',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '批号',
          key: 'goodsBatchNumber',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '数量',
          key: 'goodsQuantity',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '不含税单价',
          key: 'priceAfterTax',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '不含税金额',
          key: 'priceAfterTaxAmount',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '商品仓库',
          key: 'warehouseName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '货位',
          key: 'locationCode',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '创建人',
          key: 'createUserName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '关联单据',
          key: 'adjustCode',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '调整单据',
          key: 'referCode',
          minWidth: 116,
          tooltip: true,
        },
      ],
      tableData: [],
    };
  },
  methods: {
    handleReset() {
      this.query = {};
    },
    formatParams() {
      const params = utils.deepClone(this.params);
      console.log(params);
      params.size = this.size;
      params.page = this.page;
      if (params.range && params.range[1]) {
        params.startTime = params.range[0];
        params.endTime = params.range[1];
      }
      return params;
    },
    getDetails() {
      const params = this.formatParams();
      inventory.getInventoryDetailSummary(params).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          this.summaryList = [{
            title: '合计数量',
            value: data.inventoryCount,
          }];
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      const params = this.formatParams();
      inventory.getReportDetailsData(params)
        .then((res) => {
          if (res.data.status === 200) {
            this.tableData = [];
            this.count = res.data.data.count;
            res.data.data.list.forEach((val) => {
              const result = {};
              utils.exchangeTable(val, result);
              result.bizTypeStr = this.bizTypes.get(result.bizType);
              this.tableData.push(result);
            });
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getWarehouseList() {
      inventory.inventoryNameList()
        .then((res) => {
          if (res.status === 200) {
            this.warehouseList = res.data.data;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    download() {
      const params = this.formatParams();
      params.page = 0;
      params.size = 0;
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      inventory.stockDetailDownload(params).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.getWarehouseList();
    this.handleSearch(true, this.getDetails);
    if (this.roleType !== 2) {
      this.columns.splice(0, 0, {
        title: '门店名称',
        key: 'storeName',
        minWidth: 116,
        tooltip: true,
      });
    }
  },
};
</script>

<style lang="less" scoped>
</style>
